var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"forbidden-message"},[_vm._v("U heeft geen toegang tot deze pagina.")]),_c('hr'),_c('b-btn',{on:{"click":_vm.logout}},[_vm._v("Log out")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }